import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const Email2FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='EMAIL 2' htmlFor='input-email2' md={2} />
      <Col md={10}>
        <Field name='email2'>
          {({ field }) => (
            <Form.InputEmail
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-email2'
              placeholder='Ingresar email ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(Email2FormGroup)
